module.exports = __webpack_public_path__ + "static/hollywood-burgers-88b92d42ebc7e7cad7bef604b5d3b244.jpg";